export class FileCluster {
  private file: File;
  private clusterId: string;

  static isCsvExtension(file: File): boolean {
    return file.name.includes(".csv");
  }

  getFile(): File {
    return this.file;
  }

  setFile(file: File): void {
    this.file = file;
  }

  getClusterId(): string {
    return this.clusterId;
  }

  setClusterId(value: string): void {
    this.clusterId = value;
  }

  hasFile(): boolean {
    return !!(this.file && this.clusterId);
  }
}
